__turbopack_context__.v({
  "animate-promo-dot-fill": "VlmtRq_animate-promo-dot-fill",
  "animate-promo-fade-in": "VlmtRq_animate-promo-fade-in",
  "promo-carousel": "VlmtRq_promo-carousel",
  "promo-dot-fill": "VlmtRq_promo-dot-fill",
  "promo-fade-in": "VlmtRq_promo-fade-in",
});
